import React, { useEffect } from 'react';

import { clearAuthSession } from '../../utils/authStorage';

const LoginLayout = ({ children }) => {
  useEffect(() => {
    clearAuthSession();
  }, []);

  return (
    <div className="flex h-screen w-screen overflow-hidden text-stone-700">
      <div className="relative hidden h-screen flex-1 overflow-hidden bg-[#0D2C2C] lg:block">
        <img
          src={`${process.env.PUBLIC_URL || ''}/login_screen_hero_image.png`}
          alt="HousinGram login hero"
          className="absolute inset-0 hidden h-full w-full object-cover object-left-top 2xl:block"
        />
        <img
          src={`${process.env.PUBLIC_URL || ''}/login_hero_image_960x900.png`}
          alt="HousinGram login hero"
          className="absolute inset-0 block h-full w-full object-cover object-left-top 2xl:hidden"
        />
      </div>
      <div className="relative flex h-screen w-full shrink-0 flex-col overflow-y-auto bg-white lg:w-[440px] xl:w-[480px] 2xl:w-[520px]">
        <div className="flex min-h-full flex-1 flex-col px-6 py-10 sm:px-8 lg:px-10">{children}</div>
      </div>
    </div>
  );
};

export default LoginLayout;
